/* eslint-disable linebreak-style */
import React, { useEffect, useState } from 'react';
import s from './Blockerscreen.scss';

function Blockerscreen(props) {
  const [showBlocker, setShowBlocker] = useState(true);
  useEffect(
    () => {
      setShowBlocker(props.showToiPlusPlanPage);
    },
    [props.showToiPlusPlanPage],
  );

  return (
    <>
      {!showBlocker && (
        <div
          className={`${s.planpopup} ${s.active} `}
          showToiPlusPlanPage={`${props.showToiPlusPlanPage}`}
          showBlocker={`${!showBlocker}`}
        >
          <div className={s.common_blocker_subs}>
            <div className={s.status_content}>
              <div className={s.TP_status_page}>
                <div className={s.title}>
                  TOI+ Subscriptions aren’t available in your region
                </div>
                <div className={s.desc}>
                  Check out our other high quality TOI articles instead.
                </div>
                <a href="/">
                  <button className={s.subscription_btn}>
                    VIEW TOI STORIES
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Blockerscreen;
